module.exports = __webpack_public_path__ + "img/card-book-transfer-hover.bcb34d46.svg";